import React, { useState } from 'react';
import { Send } from 'lucide-react';

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        message: ''
    });
    const [formErrors, setFormErrors] = useState({});

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setFormErrors({
            ...formErrors,
            [e.target.name]: ''
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        let errors = {};

        if (!formData.name) errors.name = 'Entre com um nome válido.';
        if (!formData.email) errors.email = 'Entre com um email válido.';
        if (!formData.message) errors.message = 'Diga como podemos te ajudar.';

        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }

        // Abrir cliente de email diretamente
        const { name, email, message } = formData;
        const subject = encodeURIComponent('Contato via site Manage4Me');
        const body = encodeURIComponent(`Nome: ${name}\nE-mail: ${email}\nMensagem: ${message}`);
        window.location.href = `mailto:manage4me.org@gmail.com?subject=${subject}&body=${body}`;

        // Limpar formulário após envio
        // setFormData({ name: '', email: '', message: '' });
    };

    return (
        <form onSubmit={handleSubmit} className="contact-form">
            <h3 className="heading-3 mb-6 text-center">Envie sua Mensagem</h3>

            <div className="form-group">
                <label htmlFor="name" className="form-label">
                    Nome
                </label>
                <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Seu nome completo"
                />
                {formErrors.name && <span className="error-message">{formErrors.name}</span>}
            </div>

            <div className="form-group">
                <label htmlFor="email" className="form-label">
                    Email
                </label>
                <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="seu@email.com"
                />
                {formErrors.email && <span className="error-message">{formErrors.email}</span>}
            </div>

            <div className="form-group">
                <label htmlFor="message" className="form-label">
                    Mensagem
                </label>
                <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-textarea"
                    placeholder="Conte-nos sobre suas necessidades..."
                />
                {formErrors.message && <span className="error-message">{formErrors.message}</span>}
            </div>

            <button type="submit" className="btn-primary w-full flex items-center justify-center gap-2">
                <Send size={20} />
                Enviar Mensagem
            </button>
        </form>
    );
};

export default ContactForm;